import { useQuery } from 'react-query';
import { getCountryConfigs } from 'services/company-service';

/**
 * Returns country-specific field configuration for a given country code.
 * Fetches all country configs once (React Query cached) and filters client-side.
 * @param {string|undefined} countryCode - ISO 3166-1 alpha-2 (e.g., 'BR', 'CL')
 */
export const useCountryConfig = (countryCode) => {
  const { data: response, isError, isLoading } = useQuery(['countryConfigs'], getCountryConfigs, {
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });

  const allConfigs = response?.data ?? [];
  const countryConfig = countryCode
    ? allConfigs.find(c => c.countryCode === countryCode) ?? null
    : null;

  return {
    allConfigs,
    countryConfig,
    isError,
    isLoading,
    taxIdLabel: countryConfig?.taxId?.label ?? 'Tax ID',
    taxIdMask: countryConfig?.taxId?.mask ?? '',
    taxIdPlaceholder: countryConfig?.taxId?.mask
      ? `Ex: ${countryConfig.taxId.mask}`
      : '',
    phonePrefix: countryConfig?.phonePrefix ?? '',
    currency: countryConfig?.defaultCurrency ?? '',
  };
};
